import React                   from 'react';
import { graphql }             from 'gatsby';
import Img                     from 'gatsby-image';

import HeaderImage  from '@interness/web-core/src/components/media/HeaderImage/HeaderImage';
import Heading      from '@interness/web-core/src/components/text/Heading/Heading';
import Spacer       from '@interness/web-core/src/components/structure/Spacer/Spacer';
import Wrapper      from '@interness/web-core/src/components/structure/Wrapper/Wrapper';
import MCNewsletter from '@interness/web-core/src/components/structure/MCNewsletter/MCNewsletter';

function NewsletterPage(props) {
  return (
    <>
      <HeaderImage>
        <Img fluid={props.data.headerImage.childImageSharp.fluid}/>
      </HeaderImage>
      <Wrapper>
        <Spacer/>
        <Heading>Newsletter</Heading>
        <Spacer/>
        <h2 style={{textAlign: 'center'}}>Abonnieren Sie unseren Newsletter</h2>
        <div style={{textAlign: 'center'}}>
          <MCNewsletter/>
        </div>
        <Spacer/>
      </Wrapper>
    </>
  )
}

export default NewsletterPage;

export const query = graphql`
    query NewsletterPageQuery {
        headerImage: file(relativePath: {eq: "headers/contact.jpg"}) {
            name
            childImageSharp {
                fluid(maxWidth: 1980, maxHeight: 700, cropFocus: CENTER) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
    }
`;